module.exports = __webpack_public_path__ + "media/application/images/2018/2018-arrow-nav-7c0685f7d661a2def4f8d750469add57.svg";